import React from 'react';

const Tag = ({
  text,
  isSelected,
  onClick,
  className,
}: {
  text: string;
  isSelected: boolean;
  onClick: () => void;
  className?: string;
}) => {
  const selectedClassName = isSelected
    ? 'bg-blue_light_2 text-blue !border-transparent'
    : 'bg-white text-gray__dark_2 border-gray';

  return (
    <button
      className={`${className} ${selectedClassName} border py-x px-2x text-body_2 rounded-[12px]`}
      onClick={() => onClick()}
    >
      {text}
    </button>
  );
};

export default Tag;
